function helperGetDateTime (date) {
  return date.getTime()
}

module.exports = helperGetDateTime



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperGetDateTime.js
// module id = 10
// module chunks = 98